import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useFilteredCarouselItems } from '@ibk/shared-utils';
import { Carousel } from '../Carousel';
import { useBannerItems } from './hooks/useBannerItems';
import styles from './ProductBanners.module.css';
export const ProductBanners = ({ title, banners, context, homeProducts, autoPlay = true, interval = 5000, className, 'data-testid': dataTestId, }) => {
    const carouselItems = useBannerItems({
        banners,
        domain: context.domain,
        autoPlay,
    });
    const defaultFilteredItems = useFilteredCarouselItems(carouselItems, homeProducts);
    const filteredItems = context.domain === 'escritorio' ? carouselItems : defaultFilteredItems;
    if (!filteredItems?.length) {
        return null;
    }
    return (_jsxs("div", { className: `${styles.productBanners} ${className || ''}`, "data-testid": dataTestId, children: [title && _jsx("h2", { className: styles.productBannersTitle, children: title }), _jsx(Carousel, { items: filteredItems, autoPlay: autoPlay, interval: interval, "data-testid": `${dataTestId}-carousel` })] }));
};
